"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function GoogleColored16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M15.68 8.18182C15.68 7.61455 15.6291 7.06909 15.5345 6.54546H8V9.64364H12.3055C12.1164 10.64 11.5491 11.4836 10.6982 12.0509V14.0655H13.2945C14.8073 12.6691 15.68 10.6182 15.68 8.18182Z", fill: "#4285F4" }),
        react_1.default.createElement("path", { d: "M7.99997 16C10.16 16 11.9709 15.2873 13.2945 14.0655L10.6982 12.0509C9.98542 12.5309 9.07633 12.8218 7.99997 12.8218C5.91997 12.8218 4.1527 11.4182 3.51997 9.52728H0.858154V11.5927C2.17452 14.2036 4.8727 16 7.99997 16Z", fill: "#34A853" }),
        react_1.default.createElement("path", { d: "M3.52 9.52C3.36 9.04 3.26545 8.53091 3.26545 8C3.26545 7.4691 3.36 6.96 3.52 6.48V4.41455H0.858182C0.312727 5.49091 0 6.70546 0 8C0 9.29455 0.312727 10.5091 0.858182 11.5855L2.93091 9.97091L3.52 9.52Z", fill: "#FBBC05" }),
        react_1.default.createElement("path", { d: "M7.99997 3.18545C9.17815 3.18545 10.2254 3.59273 11.0618 4.37818L13.3527 2.08727C11.9636 0.792727 10.16 0 7.99997 0C4.8727 0 2.17452 1.79636 0.858154 4.41454L3.51997 6.48C4.1527 4.58909 5.91997 3.18545 7.99997 3.18545Z", fill: "#EA4335" }));
}
function GoogleColored16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(GoogleColored16Svg, Object.assign({}, svgProps)));
}
exports.default = GoogleColored16;
//# sourceMappingURL=GoogleColored16.js.map